import styled from 'styled-components';

import { rotationBackgroundAnimation, rotationForegroundAnimation } from '../DiscountRed/styles';

export const IconContainer = styled.svg`
  g > path {
    filter: drop-shadow(0px 0px 2px rgb(0 0 0 / 0.4));
  }
  .background {
    transform-origin: 0 50%;
    animation: ${rotationBackgroundAnimation} 4s infinite;
  }
  .foreground {
    transform-origin: 100% 50%;
    animation: ${rotationForegroundAnimation} 6s infinite;
  }
`;
